import React from 'react'
import AllBlogs from '../component/Admin/AllBlogs'

export default function Blog() {
  return (
    <div className=' w-full bg-[#0F172A]  ' >
        <div className=' md:mt-[6%] mt-[10%] ' >
        <AllBlogs enableDelete={false} />
        </div>
    </div>
  )
}
